import React from 'react'

const EditPancilIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={11} height={12} viewBox="0 0 11 12" fill="none">
        <g clipPath="url(#clip0_14828_8056)">
            <path d="M9.00265 5.25761L8.99621 5.251L6.22472 2.40625C6.22472 2.40625 2.84738 5.87019 1.21886 7.57572C1.01691 7.78726 0.862224 8.08253 0.77199 8.36899C0.505584 9.20633 0.284295 10.0613 0.0372243 10.9052C-0.0293773 11.1322 -0.0164867 11.3327 0.157537 11.5002C0.320818 11.6589 0.505584 11.6677 0.71613 11.6016C1.50246 11.3592 2.29308 11.13 3.08156 10.8986C3.49621 10.7774 3.84426 10.5527 4.14933 10.2376C5.70051 8.64003 9.00265 5.25761 9.00265 5.25761Z" fill="#111111" />
            <path d="M10.6199 1.72115L9.67246 0.749399C9.16543 0.229367 8.34687 0.229367 7.83984 0.749399L6.76562 1.85116L9.5457 4.70252L10.6199 3.60076C11.127 3.08293 11.127 2.24119 10.6199 1.72115Z" fill="#111111" />
            <path d="M4.95332 10.4453H10.4168C10.7391 10.4453 10.999 10.7119 10.999 11.0425C10.999 11.373 10.7391 11.6396 10.4168 11.6396H4.95332C4.63105 11.6396 4.37109 11.373 4.37109 11.0425C4.37324 10.7119 4.6332 10.4453 4.95332 10.4453Z" fill="#111111" />
        </g>
        <defs>
            <clipPath id="clip0_14828_8056">
            <rect width={11} height="11.2821" fill="white" transform="translate(0 0.359375)" />
            </clipPath>
        </defs>
    </svg>

  )
}

export default EditPancilIcon;